import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client";

type ReturnRequest = SearchReturnRequestsResponseDto["returnRequests"][number];
type LineItem = ReturnRequest["line_items"][number];

export function useLineItemImages(returnRequest: ReturnRequest): LineItem[] {
  return returnRequest.line_items.filter((li) => (li.quantity ?? 0) > 0);
}
